/**
 * Shared resolution of the feedback ingest URL.
 *
 * Error reports are POSTed to the existing `feedback/reports` endpoint rather
 * than a dedicated telemetry service. Keeping the URL in one place lets both
 * the awaited manual path ({@link ./reportError}) and the fire-and-forget auto
 * path ({@link ./queue}) target the same destination.
 */

import { ApiEndpoints } from "@/server/apiEndpoints";

const API_BASE = (import.meta.env.VITE_API_URL as string).replace(/\/+$/, "");

export const FEEDBACK_URL = `${API_BASE}/${ApiEndpoints.FEEDBACK}`;
